import axios from 'axios';
axios.defaults.xsrfHeaderName = "X-CSRFToken";
axios.defaults.xsrfCookieName = "csrftoken";

let rootUrl = '';

if (!process.env.NODE_ENV || process.env.NODE_ENV === 'development') {
  rootUrl = 'http://127.0.0.1:8000/api/';
} else {
  rootUrl = '/api/';
}

export const API_URL = rootUrl;


export const api = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json'
  },
  withCredentials: true
});
